<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <v-layout class="contact__layout">
        <v-flex xs12>
          <div class="contact__layout-card">
            <v-card>
              <v-card-title class="pa-0">
                <div class="top__layout-title">Contact</div>
              </v-card-title>
              <v-card-text>
                If you have any doubt, suggestion or you have identified any data that you believe is missing or require curation, please let us know [<a href="mailto:chemprobes@icr.ac.uk">chemprobes@icr.ac.uk</a>] to help us improve this resource for
                the community.
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  components: {
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Contact'
  },
  name: 'prbcontact',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  },
  data() {
    return {
      termsDialog: true,
      search: null,
      e1: 1
    }
  }
}
</script>

<style scoped>
.contact__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.contact__layout-card {
  padding: 5% 5% 0 5%;
}

.top__layout-title {
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}

@media screen and (max-width: 1600px) {
  .contact__layout-card {
    padding: 2% 2% 0 2%;
  }
}

@media screen and (max-width: 800px) {
  .contact__layout-card {
    padding: 2% 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// PrbContact.vue?2ab25ba2